/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { func, object, string } from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const styles = (theme) => ({
    contaier: {
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: '414px',
        '@media screen and (min-width: 768px)': {
            justifyContent: 'inherit',
            maxWidth: '100%',
        },
    },
    root: {
        color: theme.palette.white,
        backgroundColor: theme.palette.black,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '9px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.black}`,
        boxShadow: 'none',
        marginBottom: 14,
        '&:hover': {
            backgroundColor: theme.palette.black,
        },
        '@media screen and (max-width: 400px)': {
            fontSize: '12px',
            padding: '5px 12px',
        },
        '@media screen and (min-width: 768px)': {
            fontSize: '16px',
            marginRight: '15px',
            padding: '5px 22px',
        },
        '@media screen and (min-width: 1024px)': {
            padding: '5px 30px',
        },
    },
    secondaryButtonStyle: {
        backgroundColor: 'transparent',
        color: theme.palette.black,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '9px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.black}`,
        boxShadow: 'none',
        marginBottom: 14,
        '@media screen and (max-width: 400px)': {
            fontSize: '12px',
            padding: '5px 12px',
        },
        '@media screen and (min-width: 768px)': {
            fontSize: '16px',
            marginRight: '15px',
            padding: '5px 22px',
        },
        '@media screen and (min-width: 1024px)': {
            padding: '5px 30px',
        },
    },
});

class SubscriptionFilterChips extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { classes, handleFilter, activeFilter } = this.props;

        return (
            <div className={classes.contaier}>
                <Button
                    className={activeFilter === 'ALL' ? classes.root : classes.secondaryButtonStyle}
                    align="center"
                    raised="true"
                    onClick={() => handleFilter('ALL')}
                >
                    All
                </Button>
                <Button
                    className={activeFilter === 'ACTIVE' ? classes.root : classes.secondaryButtonStyle}
                    align="center"
                    raised="true"
                    onClick={() => handleFilter('ACTIVE')}
                >
                    Active
                </Button>
                <Button
                    className={activeFilter === 'PAUSED' ? classes.root : classes.secondaryButtonStyle}
                    align="center"
                    raised="true"
                    onClick={() => handleFilter('PAUSED')}
                >
                    Paused
                </Button>
                <Button
                    className={activeFilter === 'CANCELLED' ? classes.root : classes.secondaryButtonStyle}
                    align="center"
                    raised="true"
                    onClick={() => handleFilter('CANCELLED')}
                >
                    Cancelled
                </Button>
            </div>
        );
    }
}

SubscriptionFilterChips.propTypes = {
    classes: object.isRequired,
    handleFilter: func.isRequired,
    activeFilter: string.isRequired,
};

export default withStyles(styles, { withTheme: true })(SubscriptionFilterChips);
